var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LoadingButton",on:{"click":function($event){return _vm.$emit('click')}}},[_c('IconButton',{attrs:{"icon":_vm.loading ? 'loading' : _vm.icon}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }